<div class="table-wrapper">
  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <qai-loading [size]="'medium'"></qai-loading>
  </div>  

  <ng-container *ngIf="!isLoading">
    <!-- Status filter + Search -->
    <div class="filter-container">
      <qai-searchable-select
        [shape]="'rectangle'"
        [placement]="'below-start'"
        [offset]="4"
        [placeholder]="'simulationBuilder.ASSIGNMENT_STATUS_PLACEHOLDER' | transloco"
        [searchable]="false"
        [options]="statusOptions"
        [multiselect]="true"
        [value]="selectedStatusValues"
        [disabled]="hasNoAssignments"
        (valueChange)="onStatusFilterChange($event)"
        [selectionPrefix]="'simulationBuilder.ASSIGNMENT_STATUS_PREFIX' | transloco"
        [scopedOptionsSelectionMode]="visibleOptionsSelectionMode"
        [othersTextFormatter]="othersTextFormatter"
      >
      </qai-searchable-select>

      <div class="search-input-wrapper">
        <qai-field [label]="''">
          <qai-icon kind="search-lg" qaiSlot="startIcon" />
          <input
            qai-input
            size="lg"
            type="text"
            [placeholder]="'simulationBuilder.SEARCH_BY_ASSIGNMENT_NAME' | transloco"
            [value]="searchName()"
            (input)="onSearchNameChange($event)"
          />
        </qai-field>
      </div>
    </div>
  </ng-container>

  <!-- Empty State -->
  <div *ngIf="!isLoading && tableData.length === 0" class="empty-container">
    <p>{{ 'simulationBuilder.NO_ASSIGNMENTS_FOUND' | transloco }}</p>
  </div>

  <!-- Data Loaded State -->
  <qai-table
    *ngIf="!isLoading && tableData.length > 0"
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [currentPage]="currentPage"
    [initialSortColumn]="initialSortColumn"
    [initialSortDirection]="initialSortDirection"
    (rowAction)="onTableRowAction($event)"
    (rowClick)="onTableRowClick($event)"
    (pageChanged)="onPageChanged($event)"
    [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
    [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
  ></qai-table>
</div>